import {EnumDefinition} from '../classes/enum-definition';

export const CONTRACT_STATUS: EnumDefinition = {
  id: 'contractstatus',
  items: [
    {label: 'LabelContractStatusNoContract', data: 'NO_CONTRACT'},
    {label: 'LabelContractStatusPartnerContract', data: 'PARTNER_CONTRACT'},
  ]
};
